var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-to-top",class:_vm.visible ? 'show-scrollTop' : ''},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"goTop",attrs:{"type":"button","href":"#"}},[_c('i',{staticClass:"fa fa-chevron-up"})])
}]

export { render, staticRenderFns }